import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { IpSurrenderFormSubmissionComponent } from './ip-surrender-form-submission/ip-surrender-form-submission.component';
import { IpSurrenderReadonlyComponent } from './ip-surrender-readonly/ip-surrender-readonly.component';
import { IpSurrenderReportComponent } from './ip-surrender-report/ip-surrender-report.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpModule } from '../otp.module';
@NgModule({
  declarations: [IpSurrenderFormSubmissionComponent, IpSurrenderReadonlyComponent , IpSurrenderReportComponent, ] ,
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule,
    OtpModule
  ],
  
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class IpSurrenderModule { }
